import axios from 'axios'
import { productInventoryByTypeQuery } from './queries/productInventoryByHandle'
import { collectionInventoryByHandleQuery } from './queries/collectionInventoryByHandle'
import trackError from '@helpers/trackError'

export const getProductInventoryByProductType = (type: string) => {
  try {
    return getInventory(productInventoryByTypeQuery, { product_type: type })
  } catch (err) {
    trackError(new Error('getProductInventoryByProductType failed'), {
      err
    })

    return { error: err }
  }
}

export const getCollectionInventoryByHandle = (handle: string) => {
  try {
    return getInventory(collectionInventoryByHandleQuery, { handle })
  } catch (err) {
    trackError(new Error('getCollectionInventoryByHandle failed'), {
      err
    })

    return { error: err }
  }
}

const getInventory = async (
  casQuery: string,
  variables: Record<string, string>
) => {
  const { data } = await axios({
    method: 'post',
    url: `https://${process.env.CONTENT_API_DOMAIN}/graphql`,
    headers: {
      Accept: 'application/json',
      'x-api-key': process.env.CONTENT_API_API_KEY!
    },
    data: {
      query: casQuery,
      variables
    }
  })

  return data.data
}
